<template>
  <div
    id="products-select-modal"
    class="container p-0 hm-min-height-medium products-select-modal--lg"
  >
    <HMModalHeader
      :title="$t('PRODUCTS.TITLE.ADD_PRODUCTS')"
      @close="$emit('close')"
    />
    <div v-if="products" class="upload">
      <div class="mt-3 pb-5 pb-sm-0 force-width">
        <HMSearch class="mt-3" v-model="search" />
        <div class="mt-4 row">
          <div
            class="column col-md-4"
            v-for="product in filteredProducts"
            :key="product.id"
          >
            <div class="product-card-container">
              <ProductCard
                class="w-100"
                :product="product"
                :isSelectable="true"
                :animated="false"
                :active="isProductSelected(product.id)"
                @click="toggleProduct(product.id)"
              />
              <v-popover
                :delay="300"
                placement="bottom"
                popoverClass="product-popover"
                trigger="click"
              >
                <div
                  class="info-container bg-dark-gray rounded d-flex justify-content-center align-items-center pointer"
                >
                  <i class="fa fa-info-circle c-white"></i>
                </div>
                <template slot="popover">
                  <ProductSelectInfoPopover :product="product" />
                </template>
              </v-popover>
            </div>
          </div>
        </div>

        <HMModalFooter class="mt-3" @close="$emit('close')">
          <template slot="submit">
            <HMButton color="primary" @click="productsSelected">
              {{ $t('GENERAL.BUTTON.SAVE') }}
            </HMButton>
          </template>
        </HMModalFooter>
      </div>
    </div>
  </div>
</template>

<script>
import ProductCard from '@/web/components/products/ProductCard.vue';
import ProductSelectInfoPopover from './ProductSelectInfoPopover.vue';

export default {
  name: 'ProductsSelectModal',
  components: {
    ProductCard,
    ProductSelectInfoPopover,
  },
  props: {
    products: {
      type: Array,
    },
  },
  data() {
    return {
      search: null,
      selectedProductIds: [],
    };
  },
  computed: {
    filteredProducts() {
      if (!this.products) return [];
      if (!this.search) return this.products;
      return this.products.filter(
        product =>
          product.product_name
            .toLowerCase()
            .indexOf(this.search.toLowerCase()) !== -1
      );
    },
  },
  methods: {
    isProductSelected(id) {
      return this.selectedProductIds.indexOf(id) > -1;
    },
    toggleProduct(productId) {
      const index = this.selectedProductIds.indexOf(productId);
      if (index === -1) {
        this.selectedProductIds.push(productId);
      } else {
        this.selectedProductIds.splice(index, 1);
      }
    },
    productsSelected() {
      this.$parent.$emit('products-selected', this.selectedProductIds);
      this.$emit('close', this.selectedProductIds);
    },
  },
  mounted() {
    this.$trackOnPage('teacher open select products');
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.products-select-modal--lg {
  @include media-breakpoint-up(lg) {
    width: 900px;
  }
}

.hm-min-height-medium {
  min-height: 650px;
}

.tooltip.popover.product-popover.open {
  width: 600px;
}

::v-deep .v-popover {
  .trigger {
    width: 100%;
  }
}

.product-card-container {
  .v-popover {
    position: absolute;
    top: 0.5rem;
    right: 22px;
  }
}

.info-container {
  height: 24px;
  width: 24px;
  padding-top: 1px;
}
</style>

<style lang="scss">
.tooltip {
  &.popover {
    &.product-popover {
      border: none;
      max-width: 500px !important;
      width: 500px !important;
      box-shadow: 0 12px 20px rgba(44, 39, 56, 0.12);

      .popover-inner {
        max-width: 500px !important;
        width: 500px !important;
      }

      .popover-arrow {
      }
    }
  }
}
</style>
